import * as React from "react";

function SvgButtonBox(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1em"
      height="1em"
      viewBox="0 0 352 62"
      {...props}
    >
      <defs>
        <filter
          id="button-box_svg__a"
          width="105.6%"
          height="138%"
          x="-2.8%"
          y="-17%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation={3}
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
        </filter>
        <rect
          id="button-box_svg__b"
          width={340}
          height={50}
          x={0}
          y={0}
          rx={15}
        />
      </defs>
      <g transform="translate(6 5)" fill="none" fillRule="evenodd">
        <use
          fill="currentColor"
          filter="url(#button-box_svg__a)"
          xlinkHref="#button-box_svg__b"
        />
        <use fill="#FFF" xlinkHref="#button-box_svg__b" />
      </g>
    </svg>
  );
}

export default SvgButtonBox;
